import React, { useState, useEffect } from 'react'
import { getIn, Field } from 'formik'
import { Form } from 'react-bootstrap'
import { FaRegTrashAlt } from 'react-icons/fa'
import { DeliveryOption } from '../../../../models/Item'
import styles from '../listingForm.module.css'
import { RegionDropdown } from 'react-country-region-selector'
import { DeliveryRegion, Countries } from '../../../../config/enums'
import constants from '../../../../config/constants'

type Props = {
  deliveryOptions: DeliveryOption[]
  handleChange: any
  handleBlur: any
  handleTouch: any
  handleError: any
  setRegionValue: any
  country: string
  handleRemove: (index: number) => void
}

const TableDelivery = ({
  deliveryOptions,
  handleChange,
  handleBlur,
  handleTouch,
  handleError,
  handleRemove,
  setRegionValue,
  country
}: Props) => {
  const [regionOptions, setRegionOptions] = useState<Array<JSX.Element>>([])

  useEffect(() => {
    if (country === Countries.philippines) {
      let options: Array<JSX.Element> = []
      options.push(
        <option
          key={DeliveryRegion.any}
          value={DeliveryRegion.any}
          data-testid="regionOption"
        >
          Any
        </option>
      )

      const regions = constants.deliveryRegions.philippines
      regions.forEach(region => {
        options.push(
          <option key={region} value={region} data-testid="regionOption">
            {region}
          </option>
        )
      })

      setRegionOptions(options)
    }
  }, [country])

  return (
    <>
      {deliveryOptions.map((p, index) => {
        const deliveryRegion = `deliveryOptions[${index}].region`
        const deliveryRegionError = getIn(handleError, deliveryRegion)

        const deliveryCourier = `deliveryOptions[${index}].courier`
        const deliveryCourierTouched = getIn(handleTouch, deliveryCourier)
        const deliveryCourierError = getIn(handleError, deliveryCourier)

        const deliveryMinDays = `deliveryOptions[${index}].minDays`
        const deliveryMinDaysTouched = getIn(handleTouch, deliveryMinDays)
        const deliveryMinDaysError = getIn(handleError, deliveryMinDays)
        const deliveryMaxDays = `deliveryOptions[${index}].maxDays`
        const deliveryMaxDaysTouched = getIn(handleTouch, deliveryMaxDays)
        const deliveryMaxDaysErrors = getIn(handleError, deliveryMaxDays)
        const deliveryFee = `deliveryOptions[${index}].fee`
        const deliveryFeeTouched = getIn(handleTouch, deliveryFee)
        const deliveryFeeError = getIn(handleError, deliveryFee)

        return (
          <tr key={index} data-test="table-delivery">
            <td>
              {country === Countries.philippines ? (
                <Form.Control
                  as="select"
                  custom
                  name="countryId"
                  value={p.region}
                  onChange={e => {
                    setRegionValue(deliveryRegion, e.currentTarget.value)
                  }}
                  data-testid="region"
                  style={{ width: '100%' }}
                >
                  {regionOptions}
                </Form.Control>
              ) : (
                <Field
                  name={deliveryRegion}
                  as={RegionDropdown}
                  onChange={(val: string) => {
                    console.log(val)
                    setRegionValue(
                      deliveryRegion,
                      val === '' ? DeliveryRegion.any : val
                    )
                  }}
                  country={country}
                  value={p.region}
                  showDefaultOption={true}
                  className="box-region py-2"
                  defaultOptionLabel={'Any'}
                  data-testid="region"
                  style={{ width: '100%' }}
                />
              )}

              <Form.Control.Feedback type="invalid">
                {deliveryRegionError}
              </Form.Control.Feedback>
            </td>
            <td>
              <Field
                name={deliveryFee}
                as={Form.Control}
                onChange={handleChange}
                onBlur={handleBlur}
                type="number"
                min="0"
                isInvalid={deliveryFeeTouched && !!deliveryFeeError}
                placeholder="type fee"
                data-testid="fee"
              />
              <Form.Control.Feedback type="invalid">
                {deliveryFeeError}
              </Form.Control.Feedback>
            </td>
            <td>
              <Field
                name={deliveryMinDays}
                as={Form.Control}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={deliveryMinDaysTouched && !!deliveryMinDaysError}
                type="number"
                min="0"
                placeholder="min time"
                data-testid="min"
              />
              <Form.Control.Feedback type="invalid">
                {deliveryMinDaysError}
              </Form.Control.Feedback>
            </td>
            <td>
              <Field
                name={deliveryMaxDays}
                as={Form.Control}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={deliveryMaxDaysTouched && !!deliveryMaxDaysErrors}
                type="number"
                min="0"
                placeholder="max time"
                data-testid="max"
              />
              <Form.Control.Feedback type="invalid">
                {deliveryMaxDaysErrors}
              </Form.Control.Feedback>
            </td>

            <td>
              <Field
                name={deliveryCourier}
                as={Form.Control}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={deliveryCourierTouched && !!deliveryCourierError}
                placeholder="partner"
                data-testid="courier"
              />
              <Form.Control.Feedback type="invalid">
                {deliveryCourierError}
              </Form.Control.Feedback>
            </td>

            <td>
              <FaRegTrashAlt
                className={styles.deleteListing}
                onClick={() => {
                  handleRemove(index)
                }}
              />
            </td>
          </tr>
        )
      })}
    </>
  )
}

export default TableDelivery
